<template>
	<div>
		<agency-profile-projects
			:agency-id="agencyId"
		></agency-profile-projects>
		<agency-users
			:agency-id="agencyId"
		/>
	</div>
</template>

<script>
	import AgencyProfileProjects from "./AgencyProfileProjects";
	import AgencyUsers from "./AgencyUsers";

	export default {
		name: "AgencyProfileViewTemplate",
		components: {AgencyUsers, AgencyProfileProjects},
		data () {
			return {
				agencyId: this.$route.params.agencyId
			};
		}
	};
</script>

<style scoped>

</style>